module.exports = __webpack_public_path__ + "static/media/banff-52.42d239c9.jpg";